var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeskalaHeaderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 40,
    viewBox: "0 0 133 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_246)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0887 40H2.84279C1.27278 40 0 38.7328 0 37.1698V2.83025C0 1.26716 1.27278 0 2.84279 0H20.0887C31.1833 0 40.1773 8.95431 40.1773 20V20C40.1773 31.0457 31.1833 40 20.0887 40Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3623 8.24707V14.2265C22.3623 17.5288 19.6735 20.2058 16.3565 20.2058H10.3506C10.3506 13.6012 15.7285 8.24707 22.3623 8.24707Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3506 19.7942H16.3565C19.6735 19.7942 22.3623 22.4712 22.3623 25.7736V31.753C15.7285 31.753 10.3506 26.3988 10.3506 19.7942Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3867 20.2524C60.3867 17.9952 58.8559 16.5879 56.7472 16.5879C54.6385 16.5879 53.1068 17.9952 53.1068 20.2524V23.5526C53.1068 25.8094 54.6385 27.2171 56.7472 27.2171C58.8559 27.2171 60.3867 25.8094 60.3867 23.5526V20.2524ZM61.0519 28.212C60.6845 28.212 60.3867 27.924 60.3867 27.5688V26.6832C59.6084 27.8479 58.1774 28.4546 56.7472 28.4546C54.4119 28.4546 51.7764 27.1928 51.7764 23.5526V20.2524C51.7764 16.6123 54.4119 15.3504 56.7472 15.3504C58.1774 15.3504 59.6084 15.9567 60.3867 17.1218V12.1905C60.3867 11.8353 60.6845 11.5474 61.0519 11.5474C61.4193 11.5474 61.7171 11.8353 61.7171 12.1905V27.5688C61.7171 27.924 61.4193 28.212 61.0519 28.212Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.7753 20.7819H74.0677V20.1954C74.0677 17.9225 72.5343 16.5052 70.4219 16.5052C68.3095 16.5052 66.7753 17.9225 66.7753 20.1954V20.7819ZM81.5601 28.4549H70.4219C68.0825 28.4549 65.4424 27.1843 65.4424 23.5185V20.1954C65.4424 16.5297 68.0825 15.259 70.4219 15.259C72.7604 15.259 75.4005 16.5297 75.4005 20.1954V21.1671C75.4005 21.6426 75.0042 22.0281 74.515 22.0281H67.2181C66.9737 22.0281 66.7753 22.2208 66.7753 22.4585V23.5185C66.7753 25.791 68.3095 27.2087 70.4219 27.2087H81.5961L81.5601 28.4549Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5818 27.2087C83.3069 27.2087 84.8324 26.5241 84.8324 25.0826C84.8324 23.9098 84.1821 23.0298 82.6318 22.7121L79.7311 22.0771C77.9306 21.6858 76.6309 20.6839 76.6309 18.7044C76.6309 16.4318 78.8315 15.259 81.1311 15.259C83.2655 15.259 85.1435 16.283 85.6915 18.3827C85.8012 18.804 85.4868 19.2179 85.042 19.2179C84.7289 19.2179 84.4679 19.0031 84.388 18.707C84.011 17.3093 82.7196 16.5052 81.1063 16.5052C79.5307 16.5052 77.9559 17.1402 77.9559 18.7044C77.9559 19.8531 78.6062 20.4885 80.181 20.8303L82.6566 21.3681C85.0818 21.8811 86.1574 22.9809 86.1574 25.107C86.1574 27.2821 84.2819 28.4549 81.5561 28.4549",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.581 22.4605L95.7438 16.1279C95.8648 16.0034 96.0354 15.9324 96.2144 15.9324C96.7723 15.9324 97.0635 16.5615 96.6857 16.9501L92.8859 20.8589L97.6392 27.5076C97.9271 27.9106 97.6222 28.4546 97.1086 28.4546H97.0411C96.829 28.4546 96.6302 28.355 96.5113 28.1888L91.9377 21.8054L89.581 24.2321V27.8479C89.581 28.1831 89.2943 28.4546 88.9406 28.4546H88.864C88.5103 28.4546 88.2236 28.1831 88.2236 27.8479V12.1541C88.2236 11.819 88.5103 11.5474 88.864 11.5474H88.9406C89.2943 11.5474 89.581 11.819 89.581 12.1541V22.4605Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.564 27.8114V12.1903C115.564 11.8351 115.843 11.5474 116.186 11.5474C116.529 11.5474 116.807 11.8351 116.807 12.1903V27.8114C116.807 28.1666 116.529 28.4546 116.186 28.4546C115.843 28.4546 115.564 28.1666 115.564 27.8114Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.445 16.0823C106.224 16.0823 106.003 16.1923 105.885 16.4125L99.8907 27.5496C99.6696 27.9603 99.9752 28.4534 100.451 28.4534H112.438C112.914 28.4534 113.22 27.9603 112.998 27.5496L107.005 16.4125C106.886 16.1923 106.665 16.0823 106.445 16.0823ZM106.445 18.0965L111.337 27.1867H101.552L106.445 18.0965Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_246",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 16,
    width: 15,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.971 16.2729H132.21V28.536H118.971V16.2729Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_246)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.59 16.2729C125.37 16.2729 125.149 16.382 125.031 16.6003L119.044 27.64C118.823 28.0471 119.128 28.536 119.603 28.536H131.577C132.052 28.536 132.357 28.0471 132.136 27.64L126.149 16.6003C126.031 16.382 125.811 16.2729 125.59 16.2729ZM125.59 18.2696L130.477 27.2803H120.704L125.59 18.2696Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.958,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskalaHeaderIcon);
export default __webpack_public_path__ + "static/media/deskalaHeaderIcon.6d9e2cd43118c8756b04fa3bdd9650ce.svg";
export { ForwardRef as ReactComponent };